const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*.()])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      user: {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        role: 'seller',
        position: null,
        company: '',
        customPosition: '',
        gender: null,
      },
      sameAddresses: true,
      company: null,
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        // inn: v => (!v || !v.length || !this.user.type
        // || v.length >= (this.user.type === 'ooo' ? 10 : 12)) || 'ИНН заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      profile: {},
      positions: [],
      customPosition: '',
      genders: [
        {
          name: 'Мужской',
          value: 'male',
        },
        {
          name: 'Женский',
          value: 'female',
        },
      ],
      searchCity: '',
      isLoadingSuggest: false,
      cities: [],
    };
  },
  watch: {
    searchCity(city) {
      const app = this;
      if (city && city.length) {
        this.isLoadingSuggest = true;
        app.$store.getters.ax.post('profiles/api/register/load-cities', { city })
          .then((result) => {
            app.cities = result.data.cities;
          }).finally(() => {
            this.isLoadingSuggest = false;
          });
      }
    },
    'user.password': (value) => {
      const messageWrapper = document.getElementById('password_msg');
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsUnregistared() { return this.type === 'sms_noprofile_or_unregistered'; },
    isSmsNoProfile() { return this.type === 'sms_profile_unregistered'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id)?.focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        role: 'seller',
        city_id: null,
        checkedRules: false,
        checkedPers: false,
        position: null,
        company: '',
        customPosition: '',
        gender: null,
      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.searchCity = '';
      this.cities = [];

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user, position_id: app?.user?.position.id };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetPositions() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/positions')
        .then((result) => {
          app.positions = result.data.data;
        });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
    this.GetPositions();
  },
};
